import { render, staticRenderFns } from "./OneTimePassConfirmPane.vue?vue&type=template&id=f114f974&scoped=true"
import script from "./OneTimePassConfirmPane.vue?vue&type=script&lang=ts"
export * from "./OneTimePassConfirmPane.vue?vue&type=script&lang=ts"
import style0 from "./OneTimePassConfirmPane.vue?vue&type=style&index=0&id=f114f974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f114f974",
  null
  
)

export default component.exports